import { createReducer, on } from '@ngrx/store';
import { Member, OverTime, Tags } from '../../modals/UsageInsights';
import * as UsageInsightActions from './usage.insights.actions';
import { createEntityAdapter, EntityAdapter, EntityState, Update } from '@ngrx/entity';

export interface OverTimeState extends EntityState<OverTime> {
    isLoaded: boolean;
    errorMessage?: string;
}
export interface TagsState extends EntityState<Tags> {
    isLoaded: boolean;
    errorMessage?: string;
}

export const overTimeadapter: EntityAdapter<OverTime> = createEntityAdapter<OverTime>({
    selectId: (overtime: OverTime) => overtime.month
});

export type StarState = {
    receivers: Member[];
    senders: Member[];
    isLoaded: boolean;
    errorMessage?: string;
}

export const initialStarState: StarState = {
    receivers: [],
    senders: [],
    isLoaded: false,
}

export const tagadapter: EntityAdapter<Tags> = createEntityAdapter<Tags>({
    selectId: (tag: Tags) => tag.tag
});

const intialOverTimeState: OverTimeState = overTimeadapter.getInitialState({
    isLoaded: false
});
const intialTagState: TagsState = tagadapter.getInitialState({
    isLoaded: false
});

const _overTimeReducer = createReducer(
    intialOverTimeState,
    on(UsageInsightActions.overTimeLoaded, (state, { data }) => {
        return overTimeadapter.addMany(data, { ...state, isLoaded: true });
    }),
    on(UsageInsightActions.overTimeLoadError, (state, { errorMessage }) => {
        return { ...state, isLoaded: false, errorMessage }
    })
);

export function overTimeReducer(state: OverTimeState | undefined, action: any): OverTimeState {
    return _overTimeReducer(state, action);
}

const _starReducer = createReducer(
    initialStarState,
    on(UsageInsightActions.starsLoaded, (state, { data }) => {
        return { ...data, isLoaded: true };
    }),
    on(UsageInsightActions.starsLoadError, (state, { errorMessage }) => {
        return { ...state, isLoaded: false, errorMessage };
    })
);

export function starReducer(state: StarState | undefined, action: any): StarState {
    return _starReducer(state, action);
}

const _tagChartReducer = createReducer(
    intialTagState,
    on(UsageInsightActions.tagLoaded, (state, { data }) => {
        return tagadapter.addMany(data, { ...state, isLoaded: true })
    }),
    on(UsageInsightActions.tagUpdated, (state, { data }) => {
        const updates = data.map(tag => ({ id: tag.tag, changes: tag }));
        return tagadapter.updateMany(updates, { ...state, isLoaded: true })
    }),
    on(UsageInsightActions.tagLoadError, (state, { errorMessage }) => {
        return { ...state, isLoaded: false, errorMessage }
    })
);

export function tagChartReducer(state: TagsState | undefined, action: any): TagsState {
    return _tagChartReducer(state, action);
}

export const {
    selectAll
} = overTimeadapter.getSelectors();



